import { FileUpload } from '../../../../common/FileUpload';

interface MaintenanceFileUploadProps {
  selectedFiles: File[];
  onFileSelect: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onRemoveFile: (index: number) => void;
  uploadingFiles: boolean;
}

export const MaintenanceFileUpload: React.FC<MaintenanceFileUploadProps> = (props) => {
  return (
    <FileUpload
      {...props}
      inputId="maintenance-attachment-upload"
    />
  );
};
